import { OnInit, Component } from '@angular/core';
import { PermissionsService } from 'src/app/service/permissions/permissions.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];
    private perms: Set<string> = new Set();   // ✅ Siempre un Set

    constructor(private permService: PermissionsService) {}

    ngOnInit() {
        this.permService.getMyViewPermissions().subscribe({
        next: (keys: any) => {
            // ✅ Acepta array o mapa {clave:true}
            if (Array.isArray(keys)) {
            this.perms = new Set(keys);
            } else if (keys && typeof keys === 'object') {
            this.perms = new Set(Object.keys(keys));
            } else {
            this.perms = new Set();
            }
            this.initializeMenu(); // construir menú solo cuando ya hay permisos
        },
        error: () => {
            this.perms = new Set();
            this.initializeMenu();
        }
        });
    }

    // ✅ Defensivo: si aún no hay Set, devuelve false
    private can = (k: string) =>
        !!this.perms && typeof (this.perms as any).has === 'function' && this.perms.has(k);


    initializeMenu() {
    this.model = [
        {
            label: 'Admistrativo',
            icon: 'pi pi-home',
            visible: this.can('admin.view'),
            items: [
                {
                    label: 'Estadisticas',
                    icon: 'pi pi-fw pi-chart-bar',
                    visible: this.can('admin.stats.view'),
                    routerLink: ['/admin']
                },
                {
                    label: 'Cobranzas',
                    icon: 'pi pi-fw pi-dollar',
                    visible: this.can('billing.menu.view'),
                    items: [
                        {
                            label: 'Pendientes',
                            icon: 'pi pi-fw pi-list',
                            visible: this.can('billing.pending.view'),
                            routerLink: ['/admin/pendingPayment']
                        },
                        {
                            label: 'En proceso',
                            icon: 'pi pi-fw pi-pencil',
                            visible: this.can('billing.active.view'),
                            routerLink: ['/admin/paymentActive']
                        },
                        {
                            label: 'Atrasadas',
                            icon: 'pi pi-fw pi-calendar',
                            visible: this.can('billing.overdue.view'),
                            routerLink: ['/admin/paymentOverdue']
                        },
                        {
                            label: 'Emitir Boleta',
                            icon: 'pi pi-fw pi-money-bill',
                            visible: this.can('billing.ticket.view'),
                            routerLink: ['/admin/paymentTicket']
                        },
                        {
                            label: 'Finalizadas',
                            icon: 'pi pi-fw pi-folder-open',
                            visible: this.can('billing.finished.view'),
                            routerLink: ['/admin/paymentEnd']
                        },
                        {
                            label: 'Anuladas',
                            icon: 'pi pi-fw pi-times',
                            visible: this.can('billing.canceled.view'),
                            routerLink: ['/admin/paymentCanceled']
                        },
                        {
                            label: 'Demanda Judicial',
                            icon: 'pi pi-fw pi-briefcase',
                            visible: this.can('billing.judicial.view'),
                            routerLink: ['/admin/paymentJudicial']
                        },
                        {
                            label: 'En Revisión',
                            icon: 'pi pi-fw pi-eye',
                            visible: this.can('billing.revision.view'),
                            routerLink: ['/admin/paymentRevision']
                        }
                    ]
                },
                {
                    label: 'Pagos',
                    icon: 'pi pi-fw pi-dollar',
                    visible: this.can('payments.menu.view'),
                    items: [
                        {
                            label: 'Mensual',
                            icon: 'pi pi-fw pi-calendar',
                            visible: this.can('payments.month.view'),
                            routerLink: ['/admin/mensual']
                        },
                        {
                            label: 'Compañía',
                            icon: 'pi pi-fw pi-desktop',
                            visible: this.can('payments.company.view'),
                            routerLink: ['/admin/company']
                        }
                    ]
                },
                {
                    label: 'Colaboradores',
                    icon: 'pi pi-fw pi-user',
                    visible: this.can('employee.list'),
                    routerLink: ['empleados']
                },
                {
                    label: 'Supervisores',
                    icon: 'pi pi-fw pi-id-card',
                    visible: this.can('supervisores.view'),
                    routerLink: ['admin/supervisores']
                },
                {
                    label: 'Parámetros',
                    icon: 'pi pi-fw pi-sliders-h',
                    visible: this.can('params.view'),
                    routerLink: ['admin/parametros']
                },
            ]
        },
        {
            label: 'Agendamiento',
            icon: 'pi pi-fw pi-calendar',
            visible: this.can('agendamiento.horario.view') || this.can('agendamiento.pagos.view') || this.can('cupones.view') || this.can('servicios.view') || this.can('stats.resenas'),
            items: [
                {
                    label: 'Horario de atención',
                    icon: 'pi pi-fw pi-clock',
                    visible: this.can('agendamiento.horario.view'),
                    routerLink: ['/agendamiento/horario']
                },
                {
                    label: 'Pagos',
                    icon: 'pi pi-fw pi-credit-card',
                    visible: this.can('agendamiento.pagos.view'),
                    routerLink: ['/agendamiento/pagos']
                },
                {
                    label: 'Cupones',
                    icon: 'pi pi-fw pi-tag',
                    visible: this.can('cupones.view'),
                    routerLink: ['/cupones']
                },
                {
                    label: 'Tipos de asesoría',
                    icon: 'pi pi-fw pi-briefcase',
                    visible: this.can('servicios.view'),
                    routerLink: ['/servicios']
                },
                {
                    label: 'Reseñas',
                    icon: 'pi pi-fw pi-star',
                    visible: this.can('stats.resenas'),
                    routerLink: ['/apps/resenas']
                },
            ]
        },
        {
            label: 'Casos',
            icon: 'pi pi-fw pi-star-fill',
            visible: this.can('case.view'),
            items: [
                {
                    label: 'Causas',
                    icon: 'pi pi-fw pi-list',
                    visible: this.can('case.view'),
                    routerLink: ['/casos/causas']
                },
                {
                    label: 'Causas Cerradas',
                    icon: 'pi pi-fw pi-lock',
                    visible: this.can('case.closed.view'),
                    routerLink: ['/casos/caseClosed']
                },
                {
                    label: 'Causas Archivadas',
                    icon: 'pi pi-fw pi-folder',
                    visible: this.can('case.archived.view'),
                    routerLink: ['/casos/caseArchived']
                },
                {
                    label: 'Causas Canceladas',
                    icon: 'pi pi-fw pi-folder',
                    visible: this.can('case.canceled.view'),
                    routerLink: ['/casos/caseCancel']
                },
                {
                    label: 'Causas por Firmar',
                    icon: 'pi pi-fw pi-folder',
                    visible: this.can('case.signed.view'),
                    routerLink: ['/casos/caseSigned'],
                },
                {
                    label: 'Clientes',
                    icon: 'pi pi-fw pi-user',
                    visible: this.can('client.view'),
                    routerLink: ['/casos/clients']
                }
            ]
        },
        {
            label: 'Pasarela de Pagos',
            icon: 'pi pi-fw pi-credit-card',
            visible: this.can('client.pagos.create'),
            items: [
                {
                    label: 'Clientes',
                    icon: 'pi pi-fw pi-users',
                    visible: this.can('client.pagos.create'),
                    routerLink: ['/pasarela']
                }
            ]
        },
        {
            label: 'Calendario',
            icon: 'pi pi-fw pi-star-fill',
            visible: this.can('calendar.view'),
            items: [
                {
                    label: 'Tareas',
                    icon: 'pi pi-fw pi-briefcase',
                    visible: this.can('tarea.view'),
                    routerLink: ['/apps/tareas']
                },
                {
                    label: 'Asesorías',
                    icon: 'pi pi-fw pi-calendar',
                    visible: this.can('calendar.asesorias.view'),
                    routerLink: ['/apps/asesorias']
                },
                {
                    label: 'Audiencias',
                    icon: 'pi pi-fw pi-calendar',
                    visible: this.can('calendar.audiencias.view'),
                    routerLink: ['/apps/audiencia']
                },
                {
                    label: 'Turnos de asesorías',
                    icon: 'pi pi-fw pi-users',
                    visible: this.can('shift.config.view'),
                    routerLink: ['/apps/turnos']
                }
            ]
        }
    ];
}

}
